import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import socket from './modules/socket'
import order from './modules/order'
import batchpush from './modules/batchpush'
import work from './modules/work'
import rebate from './modules/rebate'
import fans from './modules/fans'
import diefans from './modules/diefans'
import brand from './modules/brand'
import demo from './modules/demo'
import googleauth from './modules/googleauth'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    socket,
    order,
    batchpush,
    work,
    rebate,
    fans,
    diefans,
    brand,
    demo,
    googleauth
  },
  state: {
    
  },
  mutations: {

  },
  actions: {

  },
  getters
})
